import React from 'react'
import classNames from 'classnames'
import { TransactionStatusEnum } from '@/@data'

const useStatusLabels = () => ({
  [TransactionStatusEnum.Failed]: 'failed',
  [TransactionStatusEnum.Success]: 'success',
  [TransactionStatusEnum.Pending]: 'pending',
})

interface Props {
  status: TransactionStatusEnum
  isTable?: boolean
  noteFailed?: string
}

const GameStatusChip: React.FC<Props> = ({ status, isTable = false, noteFailed, }) => {
  const l = useStatusLabels()

  const classes = {
    [TransactionStatusEnum.Failed]: 'bg-[#ff4c5129] text-[#FF4C51] rounded-[12px]',
    [TransactionStatusEnum.Success]: 'bg-[#28C76F] text-[#FFFFFF] rounded-[12px]',
    [TransactionStatusEnum.Pending]: 'bg-[#ff9f4329] text-[#FF9F43]',
  }

  return (
    <div className='flex items-center gap-2 w-max'>
      <div
        className={classNames(
          'rounded-4xl gap-2 cursor-pointer d-inline-flex align-center text-center',
          isTable ? 'px-2 py-1 text-sm rounded-[12px]' : 'px-2 py-1 text-base',
          classes[status]
        )}
      >
        <span className='font-medium text-[13px] capitalize'>{l[status]}</span>
      </div>
      {[TransactionStatusEnum.Failed, TransactionStatusEnum.Pending].includes(status) && noteFailed && (
        <div className="relative group">
          <div
            className={classNames(
              'flex items-center justify-center rounded-4xl gap-2 cursor-pointer text-base px-2 py-2',
              classes[status]
            )}
          >
            <i className='tabler-note' style={{ fontSize: 13 }}/>
          </div>
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10 capitalize">
            {noteFailed}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
          </div>
        </div>
      )}

    </div>
  )
}

export default GameStatusChip
